import { Link } from 'gatsby';
import { Brand, type BrandProps } from '@printdeal/ui-library';
import useSystemPages from '../../../hooks/useSystemPages';
import { getConfiguration } from '../../../helpers/Configuration';

const configuration = getConfiguration();

const mapBrandName = (brandName: string): BrandProps['brand'] | undefined => {
  switch (brandName) {
    case 'brandDrukwerkdealNL':
      return 'drukwerkdeal-nl';
    case 'brandPrintdealBE':
      return 'printdeal-be';
    case 'brandImpresstoFR':
      return 'impressto-fr';
    default:
      return undefined;
  }
};

type LogoProps = {
  className?: string;
};

const Logo = (props: LogoProps) => {
  const [homePage] = useSystemPages('home');
  const brand = mapBrandName(configuration.channel.brandName);

  if (!brand) {
    return null;
  }

  return (
    <Link to={homePage.path} {...props}>
      <Brand brand={brand} className="pd:h-6 pd:sm:h-8" />
      <span className="pd:sr-only">{configuration.channel.name}</span>
    </Link>
  );
};

export default Logo;
